import { render, staticRenderFns } from "./StatusIndex.vue?vue&type=template&id=34f3256f"
import script from "./StatusIndex.vue?vue&type=script&lang=js"
export * from "./StatusIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports